exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dicom-dropzone {\n  border: #000 2px solid;\n  border-radius: 10px;\n}\na.dicom-dropzone.item-panel {\n  text-decoration: none;\n}\n.detail-guide-text > a {\n  text-decoration: none;\n}\n.drop-active {\n  border: #1592c5 2px solid;\n  border-radius: 10px;\n}\n", ""]);

